import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { ButtonWithIcon } from '@els/els-react--button';
import { Pill } from '@els/els-react--pill';
import { ModalPanel } from '@els/els-react--modal-panel';
import { useDispatch } from 'react-redux';
import AppStorage from '@Services/AppStorage';
import { showImportModal } from '@Pages/QuickSearch/Components/BuildQuery/BuildQueryActions';
import SearchTipsModalContent from './SearchTipsModalContent/SearchTipsModalContent';

import './SearchTips.scss';

function SearchTips({ updateInputText }) {
  const [showSearchTips, setShowSearchTips] = useState(false);
  const dispatch = useDispatch();

  const handleExampleClick = (exampleText) => {
    updateInputText(exampleText);
    setShowSearchTips(false);
    AppStorage.instance.setToSessionStorage('quickSearchExampleUsed', exampleText);
  };

  return (
    <div className="search-tips">
      <ButtonWithIcon
        type="link"
        linkIconSize="xs"
        sprite="InformationOutlineCircle"
        data-e2e="search-tips-button"
        onClick={() => {
          setShowSearchTips(!showSearchTips);
        }}>
        Learn how it works
      </ButtonWithIcon>
      <sup>
        <Pill pillColor="extended-blue-3" textColor="text" condensed className="u-els-margin-left-1o2 u-els-margin-right-1o2">
          New
        </Pill>
      </sup>
      <ButtonWithIcon type="link" linkIconSize="xs" sprite="Download" data-e2e="import-button" onClick={() => dispatch(showImportModal())}>
        Import
      </ButtonWithIcon>
      {showSearchTips && (
        <ModalPanel
          className="c-els-modal--panel-custom"
          panelPosition="right"
          modalProps={{
            onClose: () => {
              setShowSearchTips(false);
            },
          }}>
          <SearchTipsModalContent onExampleClick={handleExampleClick} />
        </ModalPanel>
      )}
    </div>
  );
}

SearchTips.propTypes = {
  updateInputText: PropTypes.func.isRequired,
};

export default SearchTips;
